<template>
  <ob-modal2 :show.sync="show">
    <template slot="modal-title">
      <h4 style="font-weight:600;">
        Reject {{SubmitType== "TimesheetAndExpenses" ? `${timesheetLabel} Expense` : SubmitType == "TimesheetOnly" ? timesheetLabel: "Expense"}}
        <span
          style="color:#8595A6;font-size:12px;margin-left:14px;"
        >Start Date:{{NAOrValue(selectedReport,'FromDate')}} | End Date: {{NAOrValue(selectedReport,'ToDate')}}</span>
      </h4>
    </template>
    <template slot="modal-body">
      <div class="row">
        <div class="col-md-12">
          <label>Reason for Rejection</label><span class="validation-star">*</span>
          <ob-textarea :maxLength="1200" v-model="reasonForRejection" :class="{ 'ob-vuelidate_input-error': $v.reasonForRejection.$error }"></ob-textarea>
          <span class="ob-vuelidate_error-msg" v-if="$v.reasonForRejection.$dirty && !$v.reasonForRejection.required">Please enter Reject Reason</span>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="cancel()">Cancel</ob-button>
      <ob-button @click="reject()">Reject</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
export default {
  props: ["openRejectPopup", "selectedReport", "fromTab","SubmitType"],
  data() {
    return {
      show: false,
      reasonForRejection: ""
    };
  },
  validations(){
    return{
      reasonForRejection:{
        required
      }
    }
  },
  created() {
    this.show = this.openRejectPopup;
  },
  computed: {
     TimeSheetId() {
      // if(this.$route.name == "timesheets-list")
      // {
      //    return this.selectedReport.TimesheetId;
      // }
      return this.selectedReport.Id;
    }
  },
  watch: {
    openRejectPopup(val) {
      this.show = val;
      if (val) {
        this.resetValues();
      }
    },
    show(val) {
      this.$emit("update:openRejectPopup", val);
    }
  },
  methods: {
    cancel() {
      this.show = false;
    },
    resetValues() {
      this.reasonForRejection = "";
      this.$v.reasonForRejection.$reset();
    },
    reject() { 
      this.$v.reasonForRejection.$touch();
      if(this.$v.reasonForRejection.$invalid == false){
        this.show = false;
        var type= this.SubmitType== "TimesheetAndExpenses" ? "TimesheetExpense" : this.SubmitType == "TimesheetOnly" ? "Timesheet": "Expense"
        this.$loading({ loadingText: "Loading..." });
        let _this = this;
        ajax.put(
          `TimeSheets/Reject/${this.TimeSheetId}?employeeId=${this.selectedReport.EmployeeId}&reason=${this.reasonForRejection}&TimesheetExpenseType=${type}`,
          {},
          res => {
            if (res.data.State == true) {
                if(_this.fromTab == 'ListView')
                {
                    _this.$parent.$parent.reLoadData();
                }
                else if(_this.$route.name == "timesheets-list")
                {
                  this.$parent.$parent.$parent.$parent.reLoadData();
                }
                else
                {
                  let localEventObj = {
                    Id: _this.selectedReport.Id,
                    IsPagefullLoad: true,
                    EmployeeId: _this.selectedReport.EmployeeId,
                    Status: "Rejected",
                    type: "Timesheet"
                  };
                  _this.$parent.$parent.$parent.refetchEvents(localEventObj);
                }
              _this.$message({
                type: "success",
                message: "Rejected successfully"
              });
            } else {
              _this.$message({
                type: "error",
                message: res.data.Message
              });
            }
            _this.$loading({}).close();
          }
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
 .validation-star{
    color: #F31D1D;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/RejectTimeSheet.vue